import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { isApiError } from '@/shared/api/problem'
import { cn } from '@/shared/lib/utils'
import { Button } from '@/shared/ui/button'

interface ErrorStateProps {
  error: unknown
  onRetry?: () => void
  fullPage?: boolean
}

export function ErrorState({ error, onRetry, fullPage = false }: ErrorStateProps) {
  const { t } = useTranslation()

  const title = isApiError(error) ? error.problem.title : t('app.error')
  const requestId = isApiError(error) ? error.problem.request_id : undefined

  return (
    <div
      role="alert"
      className={cn(
        'flex flex-col items-center justify-center gap-3 p-8 text-center',
        fullPage && 'min-h-svh',
      )}
    >
      <AlertTriangle className="size-10 text-destructive" aria-hidden />
      <p className="font-semibold">{title}</p>
      {requestId ? <p className="font-mono text-xs text-muted-foreground">ID: {requestId}</p> : null}
      {onRetry ? (
        <Button variant="outline" onClick={onRetry}>
          {t('app.retry')}
        </Button>
      ) : null}
    </div>
  )
}
